// Инвентаризации — заявките, добавени с редизайна: справката с анулираните,
// последната инвентаризация на всеки склад (началният екран) и анулирането с
// причина. Заварените (create, update, getStocktake…) са още в `inventory.ts`
// и се местят тук при всяка задача, която ги докосва.
import { api } from "./client";
import type { Stocktake } from "./inventory";
import type { DocumentStatusFilter } from "./inventoryPostings";

// Мета полетата на документа (BE с редизайна). Незадължителни — стар BE не
// ги праща и справката тогава просто няма анулирани.
export type StocktakeDocument = Stocktake & {
  status?: "active" | "annulled";
  createdAt?: string | null; // кога е ВЪВЕДЕНА (≠ датата на документа)
  deletedAt?: string | null;
  deletedByName?: string | null;
  deleteReason?: string | null;
};

export type StocktakesReportParams = {
  startDate: string;
  endDate: string;
  status?: DocumentStatusFilter;
};

// Справката „Инвентаризации" (по избор и анулираните). Без склад → всички
// складове на ресторанта. Стар BE игнорира `status`.
export async function getStocktakesReport(
  params: StocktakesReportParams,
): Promise<StocktakeDocument[]> {
  const res = await api.get<StocktakeDocument[]>("/inventory/stocktakes", {
    params,
  });
  return res.data;
}

// Последната АКТИВНА инвентаризация на всеки склад (складове без
// инвентаризация липсват). `date` е датата на документа (UTC ISO).
export interface LatestStocktake {
  warehouseId: number;
  warehouseName: string | null;
  stocktakeId: number;
  date: string;
  createdByName: string | null;
}

export async function getLatestStocktakes(): Promise<LatestStocktake[]> {
  const res = await api.get<LatestStocktake[]>("/inventory/stocktakes/latest");
  return res.data;
}

// ─── Приготвени рецепти (BE `stocktake_recipes`) ─────────────────────────────
// Ястие, приготвено и чакащо продажба („Шопска салата × 3"). BE разгъва
// рецептата (бруто, под-рецептите рекурсивно) и ПРИБАВЯ съставките към
// преброеното: `lines[].counted` в заявката е НАСИПНО преброеното, а в отговора
// — сборът, с `lines[].inRecipes` = частта в рецептите. Числата са float.
export interface CreateStocktakeRecipe {
  recipeId: number;
  portions: number;
}

// Съставка от СНИМКАТА на документа (по-късна промяна на рецептата не я мени)
export interface StocktakeRecipeIngredient {
  productId: number;
  productName: string;
  unit: string | null;
  perPortion: number; // бруто за една порция
  quantity: number; // perPortion × порциите (4 знака)
}

export interface StocktakeRecipe {
  recipeId: number;
  recipeName: string;
  portions: number;
  ingredients: StocktakeRecipeIngredient[];
}

// Анулиране с причина (незадължителна; стар BE я игнорира) — същият DELETE,
// който списъкът ползваше досега.
export async function annulStocktake(
  id: number,
  annulReason: string | null,
): Promise<void> {
  await api.delete(`/inventory/stocktakes/${id}`, {
    data: annulReason ? { annulReason } : undefined,
  });
}
